// HeroBannerCarousel.jsx
import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

import { Autoplay, EffectCoverflow, EffectFade, EffectFlip } from 'swiper/modules';
import { AppName } from '../constants';

const slides = [
  {
    image: '/images/image1.jpg',
    title: `W: Wisdom`,
    subtitle: 'Understanding & exploring on the basis of reasoning, and objective thinking',
    buttonText: 'Explore',
    buttonLink: '/about',
  },
  {
    image: '/images/image2.jpg',
    title: 'I: Identity',
    subtitle: 'Understanding the creations of Allah through scheme of Allah.',
    buttonText: 'View Programs',
    buttonLink: '/programs',
  },
  {
    image: '/images/image4.jpg',
    title: 'S: Service',
    subtitle: 'The spirit of charity, kindness and helping others in need',
    buttonText: 'Get Started',
    buttonLink: '/contact',
  },
  {
    image: '/images/image5.jpg',
    title: 'E: Education',
    subtitle: 'Learning today to open doors and prepare for a bright tomorrow',
    buttonText: 'Get Started',
    buttonLink: '/contact',
  },
];

const HeroBannerCarousel = () => {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{ delay: 3000, disableOnInteraction: true }}
        loop
        slidesPerView={1}
        fadeEffect={{ crossFade: true }}
        >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                position: 'relative',
                height: { xs: '70vh', md: '90vh' },
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: 1,
                }}
              />
              <Container
                sx={{
                  position: 'relative',
                  zIndex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  textAlign: 'center',
                }}
              >
                <Typography variant="h3" fontWeight="bold" gutterBottom>
                  {slide.title}
                </Typography>
                <Typography variant="h6" sx={{ mb: 4 }}>
                  {slide.subtitle}
                </Typography>
                {/* <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  component={NavLink}
                  to={slide.buttonLink}
                >
                  {slide.buttonText}
                </Button> */}
              </Container>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default HeroBannerCarousel;
